import { CustomerContactDocument } from './customer-contact-document';

export interface CustomerContact {
  id: string;
  titleId: string;
  title: string;
  forename: string;
  surname: string;
  tel: string;
  fax: string;
  mob: string;
  ext: string;
  email: string;
  position: string;
  customerId: string;
  departmentId: string;
  contactTypeId: string;
  dateCreated: Date;
  createdById: string;
  lastUpdatedDate: Date;
  lastUpdatedById: string;
  obsolete: boolean;

  customerContactDocuments: CustomerContactDocument[];
}
